import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import Button from '../../../src/components/pages/ui/Button/Button';
import './ImageWallSimple.scss';

export default function ImageWallSimple({ fields }) {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (item, key) => {
    let result = '';

    if (item && item.fields) {
      const getImageUrlFromField = (imageField) => {
        if (!imageField?.fields) return '';

        if (isMobile) {
          return (
            imageField.fields.mobileImage?.value?.src ||
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.desktopImage?.value?.src ||
            ''
          );
        } else if (isTablet) {
          return (
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.desktopImage?.value?.src ||
            imageField.fields.mobileImage?.value?.src ||
            ''
          );
        } else {
          return (
            imageField.fields.desktopImage?.value?.src ||
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.mobileImage?.value?.src ||
            ''
          );
        }
      };

      result = getImageUrlFromField(item.fields[key]);

      return result;
    }

    return result;
  };

  return (
    <div className="ImageWallSimpleComp">
      <section className="ImageWallSimple__left">
        <div
          className="ImageWallSimple__left__image"
          style={{ backgroundImage: `url(${getImageUrl({ fields }, 'imageLeft')})` }}
        ></div>
        <div
          className="ImageWallSimple__left__image"
          style={{ backgroundImage: `url(${getImageUrl({ fields }, 'imageLeft2')})` }}
        ></div>
      </section>

      <section
        className="ImageWallSimple__right"
        style={{ backgroundImage: `url(${getImageUrl({ fields }, 'imageRight')})` }}
      ></section>
    </div>
  );
}
